export const heroData = {
  tag: "全网吃瓜即时更新",
  title: "今日吃瓜 · 一站式吃瓜入口聚合平台",
  slogan: "51今日吃瓜 / 今日吃瓜网 / 51吃瓜网 — 多入口直达，每日必吃瓜料不重样",
  description: "今日吃瓜是一站式吃瓜入口聚合页，整合51今日吃瓜、今日吃瓜网、51吃瓜网等多个热门入口，覆盖吃瓜在线、吃瓜大全、吃瓜平台等主流渠道。无论你是想追最新娱乐圈动态、网红八卦，还是社会热点瓜料，这里都为你整理了最全最快的吃瓜路径。全网吃瓜内容即时更新，每日必吃，打开本页即可一键触达各大吃瓜平台，省去反复搜索的麻烦。",
  stats: [
    { label: "覆盖吃瓜入口", value: "20+" },
    { label: "每日更新瓜料", value: "100+" },
    { label: "在线吃瓜社区", value: "50万+" },
  ],
  primaryCta: { text: "立即吃瓜", href: "#topics" },
  secondaryCta: { text: "了解详情", href: "#about" },
  heroImage: "https://readdy.ai/api/search-image?query=A%20vibrant%20and%20playful%20illustration%20of%20colorful%20social%20media%20bubbles%20and%20news%20icons%20floating%20around%20a%20central%20watermelon%20slice%20motif%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20modern%20flat%20design%20style%2C%20trending%20topic%20tags%20decorating%20the%20edges%2C%20clean%20vector%20aesthetic%2C%20Chinese%20internet%20culture%20vibe%2C%20editorial%20illustration%20quality%2C%20soft%20lighting%20with%20pop%20color%20accents&width=800&height=700&seq=hero-chigua-01&orientation=portrait"
};

export const contactData = {
  title: "投稿 / 爆料",
  subtitle: "有猛料？欢迎来投",
  description: "如果你有独家瓜料、热门线索或想成为吃瓜平台合作方，欢迎通过以下方式联系我们。吃瓜在线团队期待你的爆料，让我们一起为全网吃瓜群众带来最热乎的第一手瓜料。",
  methods: [
    { icon: "ri-mail-line", label: "爆料邮箱", value: "tougao@jinrichigua.com" },
    { icon: "ri-wechat-line", label: "微信联系", value: "chigua_tougao" },
    { icon: "ri-chat-smile-2-line", label: "在线留言", value: "页面底部留言区" },
  ]
};

export const featuresData = {
  title: "为什么选择今日吃瓜",
  items: [
    {
      icon: "ri-links-line",
      title: "多入口聚合",
      description: "整合51今日吃瓜、今日吃瓜网、51吃瓜网等20+吃瓜入口，一键触达全网热门瓜料平台，无需反复搜索。"
    },
    {
      icon: "ri-flashlight-line",
      title: "即时更新",
      description: "每日必吃瓜料实时同步，吃瓜在线、吃瓜大全、吃瓜平台内容持续刷新，确保你不错过任何一条热乎瓜。"
    },
    {
      icon: "ri-shield-check-line",
      title: "安全吃瓜",
      description: "精选正规吃瓜入口，过滤低质和风险链接，为吃瓜群众提供安全可靠的一站式吃瓜导航体验。"
    },
  ]
};

export const topicsData = {
  title: "🔥 今日热门瓜料",
  items: [
    { tag: "娱乐圈新瓜", heat: "9.8万", color: "primary" },
    { tag: "网红翻车现场", heat: "8.5万", color: "accent" },
    { tag: "明星恋情曝光", heat: "7.2万", color: "primary" },
    { tag: "综艺名场面", heat: "6.9万", color: "accent" },
    { tag: "吃瓜大全合集", heat: "6.4万", color: "primary" },
    { tag: "社会热点瓜", heat: "5.8万", color: "accent" },
    { tag: "直播带货瓜", heat: "5.2万", color: "primary" },
    { tag: "追星必吃瓜", heat: "4.7万", color: "accent" },
    { tag: "每日必吃推荐", heat: "4.3万", color: "primary" },
  ]
};

export const faqData = {
  title: "吃瓜常见问题",
  items: [
    {
      question: "今日吃瓜是什么平台？",
      answer: "今日吃瓜是一站式吃瓜入口聚合页，整合51今日吃瓜、今日吃瓜网、51吃瓜网等多个吃瓜平台入口，为吃瓜群众提供全网最全的吃瓜导航服务。我们不做原创内容，专注于帮你快速找到各个吃瓜在线渠道，省去反复搜索的麻烦。"
    },
    {
      question: "51今日吃瓜和今日吃瓜网有什么区别？",
      answer: "51今日吃瓜、今日吃瓜网、51吃瓜网都是热门的吃瓜平台，各有侧重。今日吃瓜作为入口聚合页，整理了这些平台的直达链接，你可以在本页找到所有主流吃瓜入口，按需选择浏览。每日必吃瓜料会在各平台同步更新。"
    },
    {
      question: "吃瓜大全和吃瓜平台的内容多久更新一次？",
      answer: "各大吃瓜平台的内容更新频率不同。热门吃瓜在线平台通常每小时都有新瓜料上线，吃瓜大全类站点每日集中更新。今日吃瓜作为聚合导航页，会定期核验各入口的有效性和内容质量，确保你访问的吃瓜入口始终可用。"
    },
    {
      question: "如何投稿或爆料给今日吃瓜？",
      answer: "欢迎通过投稿邮箱 tougao@jinrichigua.com 或微信 chigua_tougao 向我们提供独家瓜料线索。我们审核后会推荐到吃瓜在线对应平台。注意：请确保信息真实可靠，造谣传谣需承担法律责任。"
    },
    {
      question: "今日吃瓜入口需要注册或付费吗？",
      answer: "不需要。今日吃瓜是完全免费的吃瓜入口聚合导航页，所有吃瓜入口均可直接访问。部分被链入的吃瓜平台可能有自己的会员体系，与本页无关。我们承诺永久免费提供吃瓜导航服务，每日必吃瓜料持续更新。"
    },
  ]
};

export const carouselData = {
  title: "本周焦点吃瓜专题",
  items: [
    {
      image: "https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20news%20collage%20with%20celebrity%20silhouettes%20and%20breaking%20news%20text%20overlays%2C%20warm%20red%20and%20gold%20accents%2C%20magazine%20cover%20style%2C%20Chinese%20entertainment%20theme%2C%20bold%20typography%2C%20editorial%20design%20quality%2C%20subtle%20grain%20texture&width=600&height=400&seq=carousel-01&orientation=landscape",
      tag: "独家策划",
      title: "2026上半年娱乐圈吃瓜大盘点",
      description: "从顶流塌房到综艺名场面，回顾今年最劲爆的51个吃瓜瞬间",
      link: "#topics"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20vibrant%20social%20media%20feed%20mockup%20showing%20trending%20gossip%20posts%20in%20Chinese%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20modern%20UI%20design%20elements%2C%20notification%20badges%2C%20hashtag%20tags%2C%20clean%20flat%20layout%2C%20editorial%20quality&width=600&height=400&seq=carousel-02&orientation=landscape",
      tag: "热门追踪",
      title: "网红圈最新翻车合集：这些瓜你吃了吗",
      description: "直播带货、人设崩塌、粉丝互撕，吃瓜大全持续更新中",
      link: "#ranking"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20creative%20illustration%20of%20a%20trending%20chart%20with%20rising%20arrows%20and%20hot%20topic%20icons%2C%20Chinese%20social%20media%20theme%2C%20warm%20gradient%20from%20coral%20to%20gold%2C%20data%20visualization%20style%2C%20modern%20infographic%20design%2C%20clean%20and%20engaging&width=600&height=400&seq=carousel-03&orientation=landscape",
      tag: "数据洞察",
      title: "吃瓜平台热度排行榜：谁是本月瓜王",
      description: "基于全网吃瓜在线数据，揭秘各大平台最受关注的瓜料话题",
      link: "#ranking"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20playful%20illustration%20of%20watermelon%20slices%20floating%20among%20speech%20bubbles%20and%20news%20icons%2C%20warm%20peach%20and%20cream%20background%2C%20modern%20minimalist%20style%2C%20Chinese%20internet%20culture%20motifs%2C%20clean%20vector%20art%2C%20editorial%20quality&width=600&height=400&seq=carousel-04&orientation=landscape",
      tag: "入门指南",
      title: "吃瓜新手必看：从零开始的吃瓜之路",
      description: "51吃瓜网、吃瓜在线、吃瓜平台全攻略，每日必吃不走弯路",
      link: "#faq"
    },
  ]
};

export const cardsData = {
  title: "吃瓜快讯速递",
  items: [
    {
      image: "https://readdy.ai/api/search-image?query=A%20stylized%20magazine%20layout%20with%20a%20silhouette%20figure%20on%20stage%20receiving%20an%20award%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20elegant%20editorial%20design%2C%20Chinese%20entertainment%20theme%2C%20soft%20lighting%2C%20glamorous%20atmosphere&width=500&height=350&seq=card-01&orientation=landscape",
      tag: "最新瓜料",
      title: "某顶流明星被拍到深夜密会，粉丝集体炸锅",
      excerpt: "据51吃瓜网独家消息，近日某当红流量小生被拍到与神秘女子深夜同行，相关话题迅速登上热搜。吃瓜在线持续跟进中...",
      time: "2小时前",
      link: "#topics"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20dramatic%20split%20screen%20composition%20showing%20two%20figures%20facing%20away%2C%20warm%20amber%20and%20peach%20tones%2C%20emotional%20atmosphere%2C%20magazine%20editorial%20style%2C%20Chinese%20entertainment%20news%20theme%2C%20soft%20texture&width=500&height=350&seq=card-02&orientation=landscape",
      tag: "恋情实锤",
      title: "又一对明星官宣分手，五年感情画上句号",
      excerpt: "今日吃瓜网第一时间获取消息，知名演员与圈外女友正式宣布分手。吃瓜大全整理了两人从相识到分手的完整时间线...",
      time: "5小时前",
      link: "#topics"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20vibrant%20TV%20show%20stage%20scene%20with%20colorful%20lights%20and%20dramatic%20moment%2C%20warm%20gradient%20lighting%2C%20entertainment%20show%20aesthetic%2C%20Chinese%20variety%20show%20theme%2C%20exciting%20atmosphere%2C%20editorial%20photography%20quality&width=500&height=350&seq=card-03&orientation=landscape",
      tag: "综艺爆点",
      title: "热门综艺录制现场突发状况，导演组紧急叫停",
      excerpt: "吃瓜平台前线消息，某卫视王牌综艺最新一期录制过程中出现意外插曲。据现场观众爆料，两位嘉宾因意见不合当场争执...",
      time: "8小时前",
      link: "#topics"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20live%20streaming%20setup%20with%20products%20displayed%20on%20a%20desk%2C%20dramatic%20red%20warning%20overlay%2C%20warm%20coral%20and%20cream%20tones%2C%20social%20media%20commentary%20theme%2C%20Chinese%20ecommerce%20livestream%20aesthetic%2C%20editorial%20quality&width=500&height=350&seq=card-04&orientation=landscape",
      tag: "网红风波",
      title: "百万粉丝带货主播涉嫌虚假宣传被立案调查",
      excerpt: "每日必吃追踪报道，某知名带货主播因涉嫌在直播中夸大产品功效被市场监管部门立案。51今日吃瓜为你梳理事件始末...",
      time: "12小时前",
      link: "#topics"
    },
    {
      image: "https://readdy.ai/api/search-image?query=A%20mysterious%20silhouette%20behind%20a%20frosted%20glass%20with%20question%20marks%20floating%2C%20warm%20amber%20lighting%2C%20intriguing%20atmosphere%2C%20Chinese%20entertainment%20gossip%20theme%2C%20dramatic%20editorial%20style%2C%20soft%20texture&width=500&height=350&seq=card-05&orientation=landscape",
      tag: "独家爆料",
      title: "圈内人士爆料：某大IP选角内幕浮出水面",
      excerpt: "吃瓜大全收到圈内知情人士投稿，备受关注的年度大制作影视项目选角过程暗藏玄机。吃瓜在线为你揭秘背后的故事...",
      time: "1天前",
      link: "#topics"
    },
  ]
};

export const aboutData = {
  title: "关于今日吃瓜",
  sections: [
    {
      subtitle: "我们是谁",
      content: "今日吃瓜是一站式吃瓜入口聚合导航平台，致力于为全网吃瓜群众提供最全、最快、最安全的吃瓜入口服务。我们整合了51今日吃瓜、今日吃瓜网、51吃瓜网、吃瓜在线、吃瓜大全、吃瓜平台等主流吃瓜渠道，让每日必吃的瓜料触手可及。"
    },
    {
      subtitle: "我们的使命",
      content: "在信息碎片化的时代，吃瓜群众常常需要在多个平台间来回切换搜索瓜料。今日吃瓜的诞生就是为了解决这一痛点——一个页面，汇集全网吃瓜入口，让你不错过任何一条热乎瓜。"
    },
    {
      subtitle: "内容声明",
      content: "今日吃瓜本身不生产瓜料内容，我们仅提供各大吃瓜平台的入口导航服务。所有链接指向的内容由各吃瓜平台独立运营和管理。如涉及侵权或不实信息，请直接联系源头平台处理。"
    },
  ]
};

export const mediaData = {
  title: "吃瓜视频精选",
  items: [
    {
      thumbnail: "https://readdy.ai/api/search-image?query=A%20video%20player%20interface%20mockup%20with%20a%20play%20button%20overlay%20on%20a%20dramatic%20scene%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20entertainment%20news%20video%20theme%2C%20Chinese%20social%20media%20style%2C%20modern%20UI%20design&width=500&height=300&seq=media-01&orientation=landscape",
      tag: "热门视频",
      title: "【吃瓜在线】明星见面会现场粉丝反应炸裂",
      duration: "03:25",
      link: "#topics"
    },
    {
      thumbnail: "https://readdy.ai/api/search-image?query=A%20video%20thumbnail%20style%20image%20showing%20a%20dramatic%20confrontation%20scene%20with%20text%20overlay%2C%20warm%20amber%20lighting%2C%20Chinese%20variety%20show%20aesthetic%2C%20entertainment%20news%20theme%2C%20bold%20graphic%20design%2C%20editorial%20quality&width=500&height=300&seq=media-02&orientation=landscape",
      tag: "综艺名场面",
      title: "【吃瓜平台】综艺录制意外频出爆笑全程",
      duration: "05:18",
      link: "#topics"
    },
    {
      thumbnail: "https://readdy.ai/api/search-image?query=A%20news%20commentary%20style%20image%20with%20a%20host%20desk%20and%20graphic%20overlays%2C%20warm%20coral%20tone%2C%20Chinese%20entertainment%20news%20broadcast%20theme%2C%20professional%20studio%20setup%2C%20clean%20design%2C%20editorial%20quality&width=500&height=300&seq=media-03&orientation=landscape",
      tag: "深度解读",
      title: "【每日必吃】2026年娱乐圈风云人物盘点",
      duration: "08:42",
      link: "#topics"
    },
    {
      thumbnail: "https://readdy.ai/api/search-image?query=A%20compilation%20style%20image%20with%20multiple%20small%20scenes%20in%20a%20grid%2C%20warm%20gradient%20color%20scheme%2C%20Chinese%20social%20media%20content%20compilation%20theme%2C%20entertainment%20highlights%2C%20modern%20layout%2C%20editorial%20quality&width=500&height=300&seq=media-04&orientation=landscape",
      tag: "合集推荐",
      title: "【吃瓜大全】本月最全瓜料合集一次看过瘾",
      duration: "12:06",
      link: "#topics"
    },
  ]
};

export const appData = {
  title: "随时随地吃瓜",
  subtitle: "收藏本页，一键触达所有吃瓜入口",
  description: "今日吃瓜为移动端访问做了专门优化，在手机上也能流畅浏览所有吃瓜入口。无需下载APP，无需注册登录，打开浏览器访问本页即可畅享全网吃瓜平台导航。每日必吃瓜料随身带，通勤、午休、睡前随时随地开吃。",
  features: [
    "无需下载安装",
    "所有吃瓜入口一键直达",
    "手机浏览器完美适配",
    "每日必吃瓜料即时更新",
  ],
  cta: "收藏到首页",
  link: "#",
  image: "https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20news%20aggregation%20app%20interface%20with%20trending%20topics%20in%20Chinese%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20modern%20mobile%20UI%20design%2C%20clean%20layout%20with%20cards%2C%20entertainment%20news%20theme%2C%20editorial%20quality&width=400&height=700&seq=app-mockup-01&orientation=portrait"
};

export const rankingData = {
  title: "吃瓜热度榜",
  items: [
    { rank: 1, title: "顶流明星恋情实锤：深夜密会画面曝光", heat: "🔥 98.6万", trend: "up", change: "+12位" },
    { rank: 2, title: "知名网红直播翻车：虚假宣传遭集体维权", heat: "🔥 87.3万", trend: "up", change: "+5位" },
    { rank: 3, title: "热门综艺录制现场爆发激烈争执", heat: "🔥 76.1万", trend: "up", change: "+8位" },
    { rank: 4, title: "某大IP选角内幕：资本运作浮出水面", heat: "🔥 65.8万", trend: "down", change: "-2位" },
    { rank: 5, title: "明星夫妻疑似婚变：社交账号互相取关", heat: "🔥 58.4万", trend: "up", change: "+15位" },
    { rank: 6, title: "带货主播涉嫌售假被立案：案件最新进展", heat: "🔥 47.2万", trend: "down", change: "-3位" },
    { rank: 7, title: "2026上半年娱乐圈吃瓜大事件合集发布", heat: "🔥 39.5万", trend: "new", change: "新上榜" },
  ]
};

export const indexData = {
  title: "吃瓜专题索引",
  items: [
    { icon: "ri-star-line", title: "娱乐圈吃瓜", count: "128篇", desc: "明星八卦、恋情曝光、综艺名场面全覆盖", link: "#topics" },
    { icon: "ri-live-line", title: "网红圈吃瓜", count: "96篇", desc: "直播翻车、人设崩塌、带货争议一网打尽", link: "#topics" },
    { icon: "ri-newspaper-line", title: "社会热点瓜", count: "74篇", desc: "热点事件、社会话题、民生新闻的吃瓜视角", link: "#topics" },
    { icon: "ri-movie-2-line", title: "影视综艺瓜", count: "63篇", desc: "剧组内幕、综艺爆料、票房背后的故事", link: "#topics" },
    { icon: "ri-shopping-bag-3-line", title: "直播带货瓜", count: "51篇", desc: "主播翻车、假货曝光、平台监管动态", link: "#topics" },
    { icon: "ri-user-smile-line", title: "追星吃瓜", count: "42篇", desc: "粉丝大战、应援内幕、偶像日常爆料", link: "#topics" },
    { icon: "ri-bar-chart-2-line", title: "行业深度瓜", count: "38篇", desc: "娱乐圈资本运作、行业规则、幕后揭秘", link: "#topics" },
    { icon: "ri-archive-line", title: "历史瓜料库", count: "215篇", desc: "经典吃瓜事件回顾、考古瓜料大合集", link: "#topics" },
  ]
};

export const commentsData = {
  title: "吃瓜群众说",
  items: [
    {
      avatar: "https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20user%20avatar%20portrait%20of%20a%20young%20Chinese%20person%20with%20warm%20tone%2C%20circular%20crop%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
      name: "吃瓜小能手",
      time: "2小时前",
      content: "终于找到一个靠谱的吃瓜入口合集了！以前每天要在好几个APP里来回切换找瓜吃，现在打开这个页面就能一键跳转51吃瓜网、吃瓜在线，太方便了。每日必吃栏目也做得不错，每天都有新瓜。",
      likes: 328
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20user%20avatar%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20tone%2C%20circular%20crop%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish",
      name: "娱乐圈观察员",
      time: "6小时前",
      content: "作为资深吃瓜群众，这个聚合页简直就是福音。51今日吃瓜和今日吃瓜网的入口全都整理好了，吃瓜大全的专题也很有深度。希望以后能加入更多小众吃瓜平台，毕竟有些冷门瓜料也很有意思。",
      likes: 256
    },
    {
      avatar: "https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20user%20avatar%20portrait%20of%20a%20young%20Chinese%20man%20with%20warm%20tone%2C%20circular%20crop%2C%20clean%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
      name: "每日必吃打卡人",
      time: "1天前",
      content: "每天午休第一件事就是打开今日吃瓜看看有什么新瓜。吃瓜在线各个入口质量都很高，不像有些平台全是标题党。51吃瓜网的热度榜也挺准的，基本能反映当天最火的瓜料是啥。推荐给所有爱吃瓜的朋友！",
      likes: 189
    },
  ]
};

export const updatesData = {
  title: "吃瓜时间线",
  items: [
    { time: "2026.07.30 14:30", tag: "最新", content: "某顶流艺人被拍到与神秘女子同游日本，粉丝集体围攻工作室要求回应" },
    { time: "2026.07.30 11:15", tag: "热度", content: "网红带货翻车事件持续发酵，涉事主播直播间被平台永久封禁" },
    { time: "2026.07.30 09:00", tag: "更新", content: "吃瓜平台新增「娱乐圈资本局」专题版块，深度揭秘行业运作内幕" },
    { time: "2026.07.29 20:45", tag: "爆料", content: "知情人士向51吃瓜网投稿：某知名导演新片选角存在利益输送嫌疑" },
    { time: "2026.07.29 16:30", tag: "热点", content: "综艺节目录制现场道具倒塌，三名工作人员受轻伤，节目组公开致歉" },
    { time: "2026.07.29 13:00", tag: "更新", content: "今日吃瓜网全新改版上线，移动端访问体验大幅优化，入口更加清晰" },
    { time: "2026.07.28 22:10", tag: "独家", content: "吃瓜在线独家：某当红小花被传与经纪公司解约，天价违约金成焦点" },
    { time: "2026.07.28 17:40", tag: "热点", content: "直播带货新规出台，多名头部主播连夜下架争议商品，行业震动" },
    { time: "2026.07.28 10:00", tag: "上线", content: "每日必吃栏目正式推出「周末瓜料特辑」，每周日汇总当周最热瓜料" },
  ]
};

export const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "专题索引", href: "#index" },
  { label: "吃瓜快讯", href: "#cards" },
  { label: "随时吃瓜", href: "#app" },
  { label: "常见问题", href: "#faq" },
];